module.exports = __webpack_public_path__ + "static/media/LOGO-homepage.21ec4271.png";